import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ChangeDetectorRef, Renderer2, HostListener, NgZone } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormBuilder } from "@angular/forms";
import { BannerService } from "../../services/banner.service";
import { MessageService } from "primeng/api";
import { NewsService } from "src/app/services/news.service";
import { BlogService } from "src/app/services/blog.service";
import { RssfeedService } from "src/app/services/rssfeed";
import { TournamentsService } from "src/app/services/tournamnet.service";
import { CategoryService } from "src/app/services/category.service";
import { environment } from "src/environments/environment";
import { UserService } from "../../services/user.service";
import { RoleService } from "../../services/role.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { ProductService } from "src/app/services/product.service";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ContestService } from "src/app/services/contest.service";
import { PopupService } from "src/app/services/popup.service";
import AOS from "aos"; //AOS - 1
import { UserContestService } from "src/app/services/usercontest.service";
import { SwiperComponent, SwiperDirective, SwiperConfigInterface } from "ngx-swiper-wrapper";
import { LazyLoadEvent } from "primeng/api";
import { HomepageVideoService } from "src/app/services/homepage-video.service";
import { GeoLocationService } from "src/app/services/geo-location.service";
import { HelperService } from "src/app/_helpers/helper.service";
import { FeaturedThisWeekService } from "src/app/services/featured-this-week.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
  providers: [BannerService, MessageService],
})

export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  private destroy$ = new Subject<void>();
  private sectionObserver: IntersectionObserver;
  public loadedSections: { [key: string]: boolean } = {};
  public sectionLoading: { [key: string]: boolean } = {};
  public readonly skeletonSlides = [1, 2, 3];
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  public downloadModal: boolean = false;
  openBar = false;
  faqSection: any[];
  public loading: boolean;
  priceStructurePopup: boolean = false;
  public bannerImageList: any[] = [];
  public mobileBannerImageList: any[] = [];
  public errorMessage: string;
  public bannerList: any[];
  @ViewChild("ngOtpInput", { static: false }) ngOtpInput: any;
  tournamentList: any;
  imagedataa: any;
  Login: boolean = false;
  appDownloadPopup: boolean = true;
  featureList: any[] = [];
  rewardList: any[] = [];
  coinsRewardList: any[] = [];
  tplNews: any[] = [];
  contestListCnt = 0;
  FAQVideoPopup: boolean = false;
  public blogs = [];
  public disabled: boolean = false;  
  public config: SwiperConfigInterface = {
    direction: "horizontal",
    grabCursor: true,
    centeredSlides: true,
    effect: "coverflow",
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 3,
      slideShadows: true,
    },
    loop: false,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 2,
      },
      1560: {
        slidesPerView: 3,
      },
      2500: {
        slidesPerView: 3,
      },
    },
  };
  public isAcademy: boolean = false;
  public Top_config: SwiperConfigInterface = {
    speed: 5000,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: "auto",
    direction: "horizontal",
    grabCursor: true,
    centeredSlides: true,
    effect: "slide",
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      992: {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
      },
    },
  };
  public todayContest: SwiperConfigInterface = {
    speed: 300,
    loop: false,
    slidesPerView: 'auto',
    centeredSlides: false,
    effect: 'slide',
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: false,
    navigation: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  };
  featureListSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 2.15,
        spaceBetween: 10,
        autoplay:false,
      },
      400: {
        slidesPerView: 2.3,
        spaceBetween: 10,
        autoplay:false,
      },
      767: {
        slidesPerView: 2.3,
        spaceBetween: 0,       
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,       
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  };
  tournamentListSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.4,
        spaceBetween: 10,
          autoplay:false,
      },
      400: {
      slidesPerView: 1.4,
        spaceBetween: 10,
          autoplay:false,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView:2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  };
  newsSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
     breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView:2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },     
  };
  rewardSlider = {
    effect: 'slide',
    slidesPerView: 4,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
       320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 4,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  };
  coinsRewardSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
     breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    }, 
  };
  public faqSlider: SwiperConfigInterface = {
    speed: 300,
    loop: false,
    slidesPerView: 'auto',
    centeredSlides: false,
    effect: 'slide',
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 1,
    },
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: false,
    navigation: false,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
  };
  videoLink: SafeResourceUrl = '';
  videoTitle: any;
  defaultTournament: any[];
  isAndroid: boolean;
  isFullAndroid: boolean = false;
  isContestBanned: boolean = false;  
  public contest_config: SwiperConfigInterface = {
    direction: "horizontal",
    grabCursor: true,
    centeredSlides: false,
    effect: "slide",
    loop: true,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
        navigation: false,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: false,
        navigation: false,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: false,
        navigation: false,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 15,
        centeredSlides: false,
        navigation: false,
      },
      850: {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: false,
        navigation: {
          nextEl: ".contestnext",
          prevEl: ".contestprev",
        },
      },
      851: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
        navigation: {
          nextEl: ".contestnext",
          prevEl: ".contestprev",
        },
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
        navigation: {
          nextEl: ".contestnext",
          prevEl: ".contestprev",
        },
      },
      1199: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
        navigation: {
          nextEl: ".contestnext",
          prevEl: ".contestprev",
        },
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 0,
        navigation: {
          nextEl: ".contestnext",
          prevEl: ".contestprev",
        },
      },
    },
  };
  public courtTypeList = environment.courtTypeList;
  @ViewChild(SwiperComponent) componentRef?: SwiperComponent;
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
  private lazyLoadEvent: LazyLoadEvent;
  public loggedInUser;
  isLoggedIn: boolean = false;
  public showResendButton: boolean = false;
  public displayTime;
  public counter;
  public cityName;
  public showData: boolean = false;
  filterByCategorySelected;
  userId: any;
  contestList: any;
  userContestList: any;
  isWebView: boolean = false;
  userDetails: any;
  under18: boolean;
  public tournamentTypeList = [];
  public tournamentType: any = "Upcoming";
  public currentDate = new Date();
  public selectedYear = this.currentDate.getFullYear();
  pricePoolStructurePopup: boolean;
  twoToFour: boolean;
  fiveToSeven: boolean;
  sevenToTen: boolean;
  eightToTen: boolean;
  elevenToThirteen: boolean;
  fourteenToEighteen: boolean;
  nineteenToTwentySeven: boolean;
  twentyEightToThirtySix: boolean;
  thirtySevenToFifty: boolean;
  fiftyOnePlus: boolean;
  public contest;
  public contestListData: any = [];
  public showBalanceCoinsError: boolean = false;
  public showContestDetailSection: boolean = false;
  public tournamentId;
  public contestId: any;
  public termsAndConditionsCheck: boolean = false;
  public dontShowAgainCheck: boolean = false;
  public showTermsAndConditionError: boolean = false;
  public entryCash;
  public entryCoins;
  public isTAndCSelected: boolean = false;
  public isDontShowAgainSelected: boolean = false;
  poolCash: boolean = false;
  loginCount: any;
  showWelcomeLogin: any;
  completeProfile: boolean = false;
  isContestVerified: boolean;
  isAbove18Check: any;
  isPWAInstalled: boolean;
  homePageSections: String[] = [];
  activeSectionIndex: number = -1;
   latitude: string | null = null;
  longitude: string | null = null;
  private isUserLocationReady: boolean = false;
  private loadTournamentAfterLocationReady: boolean = false;

  constructor(private renderer: Renderer2, private bannerService: BannerService, private userContestService: UserContestService, private userService: UserService, private roleService: RoleService, private formBuilder: FormBuilder, private messageService: MessageService, private categoryService: CategoryService, private router: Router, private newsService: NewsService, private rssfeedService: RssfeedService, private blogService: BlogService, private tournamentsService: TournamentsService, private tokenStorage: TokenStorageService, private route: Router, private productService: ProductService, private contestService: ContestService, private changeDetectorRef: ChangeDetectorRef, private ngZone: NgZone, public popupService: PopupService, private sanitizer: DomSanitizer, private homePageVideoService: HomepageVideoService, private activatedRoute: ActivatedRoute, private geoLocationService: GeoLocationService, private helperService: HelperService, private featuredThisWeekService: FeaturedThisWeekService) { }

  @HostListener('window:scroll', ['$event']) onWindowScroll(event: Event) {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollY > 0 && scrollY <= 108) {
      this.activeSectionIndex = 0;
    } else if (scrollY > 108 && scrollY <= 911) {
      this.activeSectionIndex = 1;
    } else if (scrollY > 911 && scrollY <= 1292) {
      this.activeSectionIndex = 2;
    } else if (scrollY > 1292 && scrollY <= 1862) {
      this.activeSectionIndex = 3;
    } else if (scrollY > 1862 && scrollY <= 2626) {
      this.activeSectionIndex = 4;
    } else if (scrollY > 2626 && scrollY <= 3378) {
      this.activeSectionIndex = 5;
    } else if (scrollY > 3378 && scrollY <= 4508) {
      this.activeSectionIndex = 6;
    } else if (scrollY > 4508 && scrollY <= 5121) {
      this.activeSectionIndex = 7;
    } else if (scrollY > 5121 && scrollY <= 5579) {
      this.activeSectionIndex = 8;
    } else if (scrollY > 5579 && scrollY <= 6198) {
      this.activeSectionIndex = 9;
    } else if (scrollY > 6198 && scrollY <= 6674) {
      this.activeSectionIndex = 10;
    } else {
      this.activeSectionIndex = -1;
    }
  }

  ngOnInit(): void {
    this.homePageSections = ['hero', 'cardsSection', 'contestSection', 'featuredThisWeekSection', 'tournamentSection', 'estoreSection', 'newsSection', 'tplWorksSection', 'featuredArticlesSection', 'rewardSection', 'getTplCoinsSection'];
    this.renderer.addClass(document.body, 'homePage');
    const isPWAInstalled = (): boolean => {
      return window.matchMedia('(display-mode: standalone)').matches || window.navigator['standalone'] === true;
    };
    this.isPWAInstalled = isPWAInstalled();
    // this.geoLocationService.isPaidContestBanned.pipe(takeUntil(this.destroy$)).subscribe((banned) => {
    //   this.isContestBanned = banned
    // });
    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isAndroid = userAgent.includes('android') ? true : false;
    this.isFullAndroid = JSON.parse(localStorage.getItem('fullAndroid'));
    this.roleService.setCurrentActiveRoute2(this.router.url);
    this.roleService.setCurrentActiveRoute(this.route.url);
    this.tournamentTypeList = [
      { label: "Upcoming Tournaments", code: "Upcoming" },
      { label: "Current Tournaments", code: "Current" },
      { label: "Past Tournaments", code: "Past" },
    ];
    this.activatedRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res.tournamentType) {
        this.tournamentType = res.tournamentType;
      } else {
        this.tournamentType = 'Upcoming';
      }
      this.defaultTournament = this.tournamentTypeList.filter((ele) => {
        return ele.code === this.tournamentType;
      })[0];
    })
    AOS.init({ disable: "mobile" }); //AOS - 2
    this.loggedInUser = this.tokenStorage.getUser();
    this.loginCount = this.loggedInUser?.userdata?.loginCount;
    this.showWelcomeLogin = this.loggedInUser?.userdata?.showWelcomeLogin;
    const lastShownDate = localStorage.getItem("popupShown");
    if (lastShownDate !== null) {
      this.Login = true;
    }
    let dontShowAgainCheck = localStorage.getItem("dontShowAgainCheck");
    if (dontShowAgainCheck === "true") {
      this.showContestDetailSection = false;
    }
    if (this.loggedInUser && this.loggedInUser.userdata) {
      this.isContestVerified = this.loggedInUser.userdata.isContestVerified;
      this.isAbove18Check = this.loggedInUser.userdata.isAbove18;
      this.userId = this.loggedInUser.userdata.id;
      this.isLoggedIn = true;
      // this.getUserContest();
      setTimeout(() => {
        this.getUserDetails(this.userId);
      }, 700);
      if (this.loggedInUser.userdata.rolename == "academy") {
        this.isAcademy = true;
      } else {
        this.isAcademy = false;
      }
    }
    this.detectWebView();
    this.loadHomeSection('hero');
    // this.loadContest(this.lazyLoadEvent);
     this.getUserLocation();
  }

  ngAfterViewInit(): void {
    this.setupDeferredSectionLoading();
  }

  private setupDeferredSectionLoading(): void {
    const sectionIds = [
      'featuredThisWeekSection',
      'tournamentSection',
      'newsSection',
      'tplWorksSection',
      'featuredArticlesSection',
      'rewardSection',
      'getTplCoinsSection',
    ];

    if (!('IntersectionObserver' in window)) {
      sectionIds.forEach((sectionId) => this.loadHomeSection(sectionId));
      return;
    }

    this.sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        this.ngZone.run(() => {
          const sectionId = entry.target.id;
          this.loadHomeSection(sectionId);
          this.changeDetectorRef.detectChanges();
        });
        this.sectionObserver.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '350px 0px',
      threshold: 0.01,
    });

    sectionIds.forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (section) {
        this.sectionObserver.observe(section);
      }
    });
  }

  private loadHomeSection(sectionId: string): void {
    if (this.loadedSections[sectionId] || this.sectionLoading[sectionId]) {
      return;
    }

    this.sectionLoading[sectionId] = true;
    this.loadedSections[sectionId] = true;

    switch (sectionId) {
      case 'hero':
        this.getBanner();
        break;
      case 'featuredThisWeekSection':
        this.loadFeaturedThisWeekList(this.lazyLoadEvent);
        break;
      case 'tournamentSection':
        this.loadTournamentWhenLocationReady();
        break;
      case 'newsSection':
        this.getTplNews();
        break;
      case 'tplWorksSection':
        this.loadFAQVideos();
        break;
      case 'featuredArticlesSection':
        this.getBlogs();
        break;
      case 'rewardSection':
        this.getOpenCartTplShopProducts();
        break;
      case 'getTplCoinsSection':
        this.loadCoinsRewardList();
        break;
      default:
        this.sectionLoading[sectionId] = false;
        break;
    }
  }

  private loadTournamentWhenLocationReady(): void {
    if (this.isUserLocationReady) {
      this.loadTournament(this.lazyLoadEvent);
      return;
    }

    this.loadTournamentAfterLocationReady = true;
  }

  private completeUserLocationLookup(): void {
    if (this.isUserLocationReady) {
      return;
    }

    this.isUserLocationReady = true;
    if (this.loadTournamentAfterLocationReady) {
      this.loadTournamentAfterLocationReady = false;
      this.loadTournament(this.lazyLoadEvent);
    }
  }

  private loadCoinsRewardList(): void {
    this.coinsRewardList = [
      { image: "assets/images/home-page/coin1.png" },
      { image: "assets/images/home-page/coin2.png" },
      { image: "assets/images/home-page/coin3.png" },
      { image: "assets/images/home-page/coin1.png" },
      { image: "assets/images/home-page/coin2.png" },
      { image: "assets/images/home-page/coin3.png" },
    ];
    this.sectionLoading['getTplCoinsSection'] = false;
  }

  trackByFn(index: number, item: any): any {
    return item.id; // or any unique identifier for the contest
  }

  onIndexChange(event: any): void {
    // Minimal logic to handle index change
  }
  
  onSwiperEvent(event: string): void {
    // Minimal logic to handle swiper events
  }

  onClickNextSection() {
    this.activeSectionIndex++;
    if (this.activeSectionIndex === 11) {
      this.activeSectionIndex = -1;
      return;
    }
  }

  loadFAQVideos() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.homePageVideoService.getHomePageVideoWebsiteList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data: any) => {
        this.loading = false;
        this.faqSection = data.data.items;
        this.sectionLoading['tplWorksSection'] = false;
      },
      (err) => {
        this.errorMessage = err.error.message;
        this.sectionLoading['tplWorksSection'] = false;
      }
    );
  }

  onNavigateToTournaments() {
    let initialTournamentPaginationvalues = { page: 1, limit: 10, tab: 2 }
    window.localStorage.setItem('tournament-pagination', JSON.stringify(initialTournamentPaginationvalues));
  }

  detectWebView() {
    var standalone = "standalone" in navigator && (navigator as any).standalone;
    var userAgent = window.navigator.userAgent.toLowerCase();
    var safari = /safari/.test(userAgent);
    var ios = /iphone|ipod|ipad/.test(userAgent);
    var mobile = /mobile/.test(userAgent);
    // var webview = /webview/.test(userAgent);
    if (ios) {
      if (!standalone && safari) {
        // Safari
        this.isWebView = false;
      } else if (!standalone && !safari) {
        // iOS webview
        this.isWebView = true;
      }
    } else {
      if (userAgent.includes("wv")) {
        // Android webview
        this.isWebView = true;
      } else {
        // Chrome
        this.isWebView = false;
      }
    }
    if (mobile) {
      if (!standalone && mobile) {
        // Mobile
        this.appDownloadPopup = false;
        this.Login = true;
      }
    }
  }

  isCordova(): boolean {
    return (
      window.hasOwnProperty("cordova") || window.hasOwnProperty("PhoneGap")
    );
  }

  isCrosswalk(): boolean {
    return window.hasOwnProperty("Crosswalk");
  }

  isWebViewUserAgent() {
    // Check for a specific user agent string that may indicate a WebView
    return /iPhone|iPad|iPod|Android|IEMobile|BlackBerry|WebView/i.test(
      navigator.userAgent
    );
  }

  timer(minute) {
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;
      this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(timer);
        this.showResendButton = true;
      }
    }, 1000);
    if (minute == 0) {
      this.displayTime = 0;
      clearInterval(timer);
    }
  }

  loadTournament(event: LazyLoadEvent) {
    this.lazyLoadEvent = event;
    let pagenumber = 1;
    let params = "";
    let rows = 5;
    let query = "filterByDisable=false&filterByStatus=true";
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 5;
      }
    }
    if (this.cityName != null) {
      query += "&filterByCityName=" + this.cityName;
    }
    if (this.filterByCategorySelected != null) {
      query += "&filterByCategory=" + this.filterByCategorySelected;
    }
    if (this.tournamentType == "Past") {
      query += "&filterByPastTournament=true";
    }
    if (this.tournamentType == "Current") {
      query += "&filterByCurrentTournament=true";
    }
    if (this.selectedYear != null) {
      query += "&filterByYears=" + this.selectedYear;
    }
    if (this.latitude !== null) {
      query += "&filterByLatitude=" + this.latitude;
    }
    if (this.longitude !== null) {
      query += "&filterByLongitude=" + this.longitude;
    }
    if (this.tournamentType == "Past") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params + "&sortBy=distance&orderBy=DESC";
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params + "&sortBy=distance&orderBy=ASC";
    }
    this.tournamentsService.getTournamentsListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.loading = false;
      this.tournamentList = data.data.items;
      if (this.tournamentList.length > 0) {
        this.showData = true;
      } else {
        this.showData = false;
      }
      this.tournamentList.forEach((element) => {
        element.isViewMore = false;
        this.imagedataa = element["academyPic"];
        let groupdt = [];
        if (element["tournamentCategories"]) {
          if (element["tournamentCategories"].length > 0) {
            element["tournamentCategories"].forEach((tmp) => {
              groupdt.push(tmp["matchtypeData"][0]["name"]);
            });
            element.matchtype = groupdt.toString();
          } else {
            element.matchtype = "";
          }
        }
        let tmp = this.courtTypeList.find(
          (o) => o.value === element["courttype"]
        );
        if (tmp != undefined) {
          element.court = tmp.label;
        } else {
          element.court = "";
        }
        let tmpcat = [];
        let pointsData = [];
        let entryFeeData = [];
        let t = element.tournamentCategories;
        if (t != undefined) {
          t.forEach((catelement) => {
            tmpcat.push(catelement.matchtypeData);
            pointsData.push(catelement.pointStructureData);
            entryFeeData.push(catelement.entryFee);
          });
        }
        let minimumEntryFee = (entryFeeData.length > 0) ? Math.min(...entryFeeData) : null;
        let maximumEntryFee = (entryFeeData.length > 0) ? Math.max(...entryFeeData) : null;
        element.minimumEntryFee = minimumEntryFee;
        element.maximumEntryFee = maximumEntryFee;
        let uniqueData = [];
        let uniqueIds = {};
        tmpcat.forEach((item) => {
          if (!uniqueIds[item[0]["name"]]) {
            uniqueIds[item[0]["name"]] = true;
            uniqueData.push(item[0]["name"]);
          }
        });
        let uniquePointsData = [];
        pointsData.forEach((item) => {
          if (!uniquePointsData.includes(item[0]['name'].replace(' Points', ''))) {
            uniquePointsData.push(item[0]['name'].replace(' Points', ''));
          }
        })
        element.matchDataName = uniqueData.length > 0 ? uniqueData : null;
        element.pointsDataName = uniquePointsData;
      });
      this.sectionLoading['tournamentSection'] = false;
    },
    (err) => {
      this.errorMessage = err.error.message;
      this.sectionLoading['tournamentSection'] = false;
    });
  }

  viewMoreCategoriesToggleOption(tournament) {
    tournament.isViewMore = !tournament.isViewMore;
  }

  pointsDataNameCheckFunc(tournament) {
    let isPoinstDataNamesAvailable = Object.keys(tournament).includes('pointsDataName');
    return isPoinstDataNamesAvailable;
  }

  matchDataNameCheckFunc(tournament) {
    let isMatchDataNamesAvailable = Object.keys(tournament).includes('matchDataName');
    return isMatchDataNamesAvailable;
  }

  onclickTournamentdetails(id) {
    this.route.navigate(["tournaments/factsheet/" + id], { queryParams: { tournamentType: this.tournamentType } });
  }

  getTplNews() {
    var query = "?filterByDisable=false&filterByStatus=true";
    this.newsService.getNewsList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        if (data.data.totalCount > 0) {
          this.tplNews = data.data.items;
        }
        this.sectionLoading['newsSection'] = false;
      },
      (err) => {
        this.errorMessage = err.error.message;
        this.sectionLoading['newsSection'] = false;
      }
    );
  }

  getBlogs() {
    var query = "?filterByDisable=false&filterByStatus=true&orderBy=Desc";
    this.blogService.getBlogListwithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.loading = false;
      if (data.data.totalCount > 0) {
        this.blogs = data.data.items;
      }
      this.sectionLoading['featuredArticlesSection'] = false;
    },
    (err) => {
      this.errorMessage = err.error.message;
      this.sectionLoading['featuredArticlesSection'] = false;
    });
  }

  getBanner() {
    let query ="?filterByDisable=false&filterByStatus=true&filterBySlug=homefirstbanner";
    this.bannerService.getbannerList(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.bannerList.forEach((element) => {
          this.bannerImageList = element.banner_image;
          this.mobileBannerImageList = element.mobile_banner_image;
        });
        this.sectionLoading['hero'] = false;
      },
      (err) => {
        this.errorMessage = err.error.message;
        this.sectionLoading['hero'] = false;
      }
    );
  }

  public toggleDisabled(): void {
    this.disabled = !this.disabled;
  }

  public toggleKeyboardControl(): void {
    this.config.keyboard = !this.config.keyboard;
  }

  public toggleMouseWheelControl(): void {
    this.config.mousewheel = !this.config.mousewheel;
  }

  getOpenCartTplShopProducts() {
    const apiToken = this.tokenStorage.getOpenCartApiToken();
    const query = `route=api/products&api_token=${apiToken}&limit=12&filter_status=1&filter_purchase_type=coin`;
    this.productService.getOpenCartTplShopProducts(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        this.rewardList = data?.products || [];        
        this.sectionLoading['rewardSection'] = false;
      }, err => {
        this.helperService.openCartLogin();
        setTimeout(() => {
          this.getOpenCartTplShopProducts();
        }, 500);
      })
  }

  getUserDetails(userId) {
    this.userService.getUserDetails(userId).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.userDetails = data;
      if (this.userDetails.age < 18) {
        this.under18 = true;
      }
      // this.loadContest(this.lazyLoadEvent);
    });
  }

  // getUserContest() {
  //   let query =
  //     "filterByDisable=false&filterByStatus=true&filterByUserId=" + this.userId;
  //   this.userContestService.getUserContestList(query).pipe(takeUntil(this.destroy$)).subscribe(
  //     (data) => {
  //       this.userContestList = data.data.items;
  //       this.loadContest(this.lazyLoadEvent);
  //     },
  //     (err) => { }
  //   );
  // }

  // loadContest(event: LazyLoadEvent) {
  //   this.lazyLoadEvent = event;
  //   let pagenumber = 1;
  //   let params = "";
  //   let rows = 10;
  //   let query = "?filterByDisable=false&filterByStatus=true";
  //   if (this.isLoggedIn == true) {
  //     query += "&filterByUserId=" + this.userId;
  //     query += "&filterByUserIdCheck=true";
  //   }
  //   if (this.under18 == true) {
  //     query += "&filterByFreeContest=true";
  //   }
  //   if (this.isAndroid && !this.isFullAndroid) {
  //     query += "&filterByIsAndroid=true";
  //   }
  //   if (this.isContestBanned) {
  //     query += "&filterByIsContestBanned=true";
  //   }
  //   if (event !== undefined) {
  //     if (event.first != undefined && event.first == 0) {
  //       pagenumber = event.first + 1;
  //     } else if (event.first != undefined && event.first > 0) {
  //       pagenumber = event.first / event.rows + 1;
  //     } else {
  //       pagenumber = 1;
  //     }
  //     if (event.rows != undefined) {
  //       rows = event.rows;
  //     } else {
  //       rows = 10;
  //     }
  //   }
  //   query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
  //   let date = new Date();
  //   query += "&filterByDateAndTime=" + moment(date).utc().format("YYYY-MM-DD");
  //   query += '&sortBy=matchDate&orderBy=ASC';
  //   this.contestService.getContestListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe(
  //     (data) => {
  //       this.loading = false;
  //       let matchFinishedFilterData = data.data.items.filter((contest) =>
  //         contest.tournamentMatchStatus !== 'finished'
  //       );
  //       this.contestList = matchFinishedFilterData;
  //       if (this.isLoggedIn == true) {
  //         if (this.userContestList != undefined) {
  //           this.userContestList.forEach((element) => {
  //             this.contestList.forEach((contest) => {
  //               if (element.contestId == contest.id) {
  //                 contest.isContestRegistrationComplete =
  //                 element.isContestRegistrationComplete;
  //                 contest.userContestId = element.id;
  //               }
  //             });
  //           });
  //         }
  //       }
  //       this.contestList.forEach((element) => {
  //         const heading = "Hi,";
  //         var subheading;
  //         if (element.giveAway) {
  //           subheading =
  //             "I am inviting you to join the TPL Contest and " + '*' + element.giveAway + '*' + " in the match between " +
  //             element.player1Name +
  //             " and " +
  //             element.player2Name +
  //             " in the " +
  //             element.tournamentCategoryName +
  //             " " +
  //             element.tournamentName +
  //             " 2025 🎾";
  //         } else {
  //           subheading =
  //             "I am inviting you to join the TPL Contest between " +
  //             element.player1Name +
  //             " and " +
  //             element.player2Name +
  //             " in the " +
  //             element.tournamentCategoryName +
  //             " " +
  //             element.tournamentName +
  //             " 2025 🎾";
  //         }
  //         const entryfees = 'Entry Fees : ' + element.entryFee;
  //         const Cashcoinprizepool = element.updatedPoolCash > 0 ? 'Cash' : 'Coins';
  //         const prizepool = '*Prize Pool 💰*: ' + `*${element.updatedPoolCash > 0 ? element.updatedPoolCash : element.updatedPoolCoins}*`;
  //         const Cashcoinentryfess = element.updatedPoolCash > 0 ? '*Cash*' : '*Coins*';
  //         const deadline = 'Deadline ⏰: ' + moment(element.matchDate).format('MMMM D, h:mm A');
  //         var prizeText;
  //         if (element.giveAway) {
  //           prizeText = '\n' + '\n' + '*1st Prize: TPL COINS + ' + element.giveAway + "*";
  //         } else {
  //           prizeText = '';
  //         }
  //         const text = "*_Tap the link below to join the contest:_*";
  //         const siteIconUrl = (this.isFullAndroid) ? 'https://www.tplsport.com/contest?fullAndroid=true' : 'https://www.tplsport.com/contest/'; // Replace with your site's icon URL
  //         const messageText = 'Hurry Up! Convert your tennis skills into ' + (element.updatedPoolCash > 0 ? 'Cash' : 'Coins') + ' now!';
  //         // Construct the WhatsApp sharing URL
  //         const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + entryfees + ' ' + Cashcoinprizepool + '\n' + '\n' + prizepool
  //           + ' ' + Cashcoinentryfess + '\n' + '\n' + deadline + prizeText + '\n' + '\n' + text + '\n' + siteIconUrl + '\n' + '\n' + messageText);
  //         element.shareurl = `https://api.whatsapp.com/send?text=${message}&image=${siteIconUrl}`;
  //         if (element.updatedPoolCoins > 0) {
  //           this.entryCash = Number(element.entryFee) / Number(10);
  //           this.entryCoins = element.entryFee;
  //         } else if (element.updatedPoolCash > 0) {
  //           this.entryCash = element.entryFee;
  //           this.entryCoins = Number(element.entryFee) * Number(10);
  //         }
  //       });
  //       this.contestList.forEach((cElement) => {
  //         let tournamentstr = cElement.tournamentName;
  //         if (cElement.tournamentName != undefined) {
  //           let tournamentarr = tournamentstr.split(",");
  //           if (tournamentarr.length > 0) {
  //             cElement.displaytournamentName = tournamentarr[0];
  //           } else {
  //             cElement.displaytournamentName = tournamentstr;
  //           }
  //         } else {
  //           cElement.displaytournamentName = tournamentstr;
  //         }
  //         let startTime = moment(new Date());
  //         let end = moment(cElement.matchDate);
  //         let duration = moment.duration(end.diff(startTime));
  //         let hours = duration.asHours();
  //         let counter = Number(hours) * Number(3600);
  //         cElement["time"] = counter;
  //         cElement["timerInterval"] = setInterval(() => {
  //           let seconds = cElement["time"];
  //           let dayTime = 60 * 60 * 24;
  //           let day = Math.floor(seconds / dayTime);
  //           let remainingTime = seconds - dayTime * day;
  //           let hoursTime = 60 * 60;
  //           let hour = Math.floor(remainingTime / hoursTime);
  //           remainingTime = remainingTime - hoursTime * hour;
  //           let minTime = 60;
  //           let minute = Math.floor(remainingTime / minTime);
  //           remainingTime = remainingTime - minTime * minute;
  //           let second = Math.floor(remainingTime);
  //           cElement["time"]--;
  //           if (day >= 0) {
  //             if (day >= 2 && hour >= 0 && minute >= 0 && second >= 0) {
  //               cElement["displayTime"] = day + " Days";
  //             } else if (day > 0 && hour >= 0 && minute >= 0 && second >= 0) {
  //               cElement["displayTime"] = day + " Days " + hour + " Hours";
  //             } else if (day <= 0 && hour > 0 && minute >= 0 && second >= 0) {
  //               cElement["displayTime"] =
  //                 hour + " : " + minute + " : " + second + " Hrs";
  //             } else if (day <= 0 && hour == 0 && minute > 0 && second >= 0) {
  //               cElement["displayTime"] = minute + " : " + second + " Minutes";
  //             } else if (day <= 0 && hour == 0 && minute == 0 && second > 0) {
  //               cElement["displayTime"] = second + " Seconds left";
  //             } else if (day <= 0 && hour <= 0 && minute <= 0 && second <= 0) {
  //               cElement["displayTime"] = "Match Started";
  //             }
  //           }
  //           this.changeDetectorRef.detectChanges();
  //         }, 1000);
  //       });
  //       this.contestListCnt = this.contestList.length;
  //       this.contestList.sort((a, b) => moment(a['matchDate']).unix() - moment(b['matchDate']).unix());
  //       this.changeDetectorRef.detectChanges();
  //       if (this.contestListCnt > 3) {
  //         this.contest_config.loop = true;
  //       } else {
  //         this.contest_config.loop = false;
  //       }
  //     },
  //     (err) => {
  //       this.errorMessage = err.error.message;
  //     }
  //   );
  // }

  loadFeaturedThisWeekList(event: LazyLoadEvent) {
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    this.featuredThisWeekService.getFeaturedThisWeek(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.featureList = data.items.items;
      this.sectionLoading['featuredThisWeekSection'] = false;
    }, (error) => {
      this.sectionLoading['featuredThisWeekSection'] = false;
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  onClickRejoin(contest) {
    let currentUrl = "/contest-details/" + contest.id;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    setTimeout(() => {
      if (contest?.updatedPoolCoins !== null && contest?.updatedPoolCoins > 0) {
        this.router.navigate([currentUrl], { queryParams: { contestJoin: false, tplCoins: true, resumeContest: true } });
      } else {
        this.router.navigate([currentUrl], { queryParams: { contestJoin: false, tplCoins: false, resumeContest: true } });
      }
    }, 200);
  }

  onClickLive(contest) {
    this.router.navigateByUrl("/contest-leader-board/" + contest.id);
  }

  showPrizePoolNewstructure(contest) {
    this.pricePoolStructurePopup = true;
    if (contest.totalEntries >= 0 && contest.totalEntries <= 4) {
      this.twoToFour = true;
      this.fiveToSeven = false;
      this.sevenToTen = false;
      this.eightToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 5 && contest.totalEntries <= 7) {
      this.fiveToSeven = true;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.eightToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 8 && contest.totalEntries <= 10) {
      this.eightToTen = true;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.elevenToThirteen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 11 && contest.totalEntries <= 13) {
      this.elevenToThirteen = true;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.fourteenToEighteen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 14 && contest.totalEntries <= 18) {
      this.fourteenToEighteen = true;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.nineteenToTwentySeven = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 19 && contest.totalEntries <= 27) {
      this.nineteenToTwentySeven = true;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.twentyEightToThirtySix = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 28 && contest.totalEntries <= 36) {
      this.twentyEightToThirtySix = true;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.thirtySevenToFifty = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 37 && contest.totalEntries <= 50) {
      this.thirtySevenToFifty = true;
      this.twentyEightToThirtySix = false;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
      this.fiftyOnePlus = false;
    }
    if (contest.totalEntries >= 51) {
      this.fiftyOnePlus = true;
      this.thirtySevenToFifty = false;
      this.twentyEightToThirtySix = false;
      this.nineteenToTwentySeven = false;
      this.fourteenToEighteen = false;
      this.elevenToThirteen = false;
      this.eightToTen = false;
      this.fiveToSeven = false;
      this.twoToFour = false;
      this.sevenToTen = false;
    }
  }

  onClickJoin(contest) {
    if (Object.keys(this.loggedInUser).length === 0) {
      this.route.navigate(['/']);
      return;
    }
    this.contest = contest;
    if (contest?.poolCash > 0 && contest?.poolCash !== null) {
      if (this.loggedInUser.userdata.isProfileComplete === false) {
        this.completeProfile = true;
        return;
      }
    } else {
      if (this.loggedInUser?.userdata?.isContestVerified === false) {
        this.completeProfile = true;
        return;
      }
    }
    this.contestListData = [];
    this.contestListData.push(contest);
    this.showBalanceCoinsError = false;
    if (this.isLoggedIn == false) {
      this.Login = true;
    } else {
      let dontShowAgainCheck = localStorage.getItem("dontShowAgainCheck");
      if (dontShowAgainCheck === "true") {
        this.showContestDetailSection = false;
        this.termsAndConditionsCheck = true;
        this.onClickSubmit();
      } else {
        this.showContestDetailSection = true;
      }
      this.showTermsAndConditionError = false;
      this.contestId = contest.id;
      this.tournamentId = contest.tournamentId;
      if (contest.updatedPoolCoins > 0) {
        this.entryCash = Number(contest.entryFee) / Number(10);
        this.entryCoins = contest.entryFee;
      } else if (contest.updatedPoolCash > 0) {
        this.entryCash = contest.entryFee;
        this.entryCoins = Number(contest.entryFee) * Number(10);
      }
    }
  }

  async onClickSubmit() {
    if (this.termsAndConditionsCheck == false) {
      this.showTermsAndConditionError = true;
      return;
    }
    this.isTAndCSelected = false;
    this.isDontShowAgainSelected = false;
    this.showContestDetailSection = false;
    if (this.dontShowAgainCheck === true) {
      localStorage.setItem("dontShowAgainCheck", "true");
    } else {
      localStorage.setItem("dontShowAgainCheck", "false");
    }
    if (this.contest?.updatedPoolCoins !== null && this.contest?.updatedPoolCoins > 0) {
      this.addContest(0, this.contest?.entryFee);
    } else {
      this.addContest(this.contest?.entryFee, 0);
    }
  }

  async addContest(cash, coins) {
    let userContestData = {
      cash: cash,
      coins: coins,
      contestId: this.contestId,
      userId: this.userId,
      tournamentId: this.tournamentId,
      termsAndConditions: this.termsAndConditionsCheck,
      dontShowAgain: this.dontShowAgainCheck,
    };
    this.userContestService.addUserContest(userContestData).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        if (this.contest?.updatedPoolCoins !== null && this.contest?.updatedPoolCoins > 0) {
          window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
          setTimeout(() => {
            let currentUrl = '/contest-details/' + this.contestId;
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            setTimeout(() => {
              this.router.navigate([currentUrl], { queryParams: { tplCoins: true } })
            }, 200);
          }, 200);
          return;
        }
        if (this.contest?.updatedPoolCash !== null && this.contest?.updatedPoolCash > 0) {
          window.localStorage.setItem('contest-details-thankyou-page-display', JSON.stringify(false));
          setTimeout(() => {
            let currentUrl = "/contest-details/" + this.contestId;
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = "reload";
            setTimeout(() => {
              this.router.navigate([currentUrl], { queryParams: { tplCoins: false } });
            }, 200);
          }, 200);
          return;
        }
      },
      (err) => { }
    );
  }

  onCloseShowContestDetailSection() {
    this.isTAndCSelected = false;
    this.isDontShowAgainSelected = false;
  }

  showOldPoolstructure() {
    this.priceStructurePopup = true;
    this.showContestDetailSection = false;
  }

  onTermsAndConditionsSelect(event) {
    if (event.checked) {
      this.termsAndConditionsCheck = true;
      this.showTermsAndConditionError = false;
      this.isTAndCSelected = true;
    } else {
      this.termsAndConditionsCheck = false;
      this.isTAndCSelected = false;
    }
  }

  showVideoDialog(youtubechannelurl: string, title) {
    const url = `${youtubechannelurl}?autoplay=1&mute=0`; // Append autoplay and mute parameters 
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.videoTitle = title;
    this.FAQVideoPopup = true; // Show the dialog
  }

  public toggleField() {
    this.openBar = !this.openBar;
  }

  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
    this.position = position;
    this.downloadModal = true; 
  }

  getUserLocation(){
       this.geoLocationService.getGeoLocation().pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.latitude = data.latitude;
      this.longitude = data.longitude;
      this.completeUserLocationLookup();
    }, () => {
      this.completeUserLocationLookup();
    })
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'homePage');
    if (this.sectionObserver) {
      this.sectionObserver.disconnect();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
